import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import Head from 'next/head';
import Keywords from '@app/components/Keywords';
import Description from '@app/components/Description';
import DesktopSlider from '@app/components/SliderHome/Desktop';
import JobFloatingButton from '@app/components/JobFloatingButton';
import gtmTracking, { gtmTrackingWithRegion, pushPageMetadata } from '@app/utils/gtmTracking';
import { isClient } from '@app/utils';
import { getValuePatternFromTheme, getSliderFromTheme } from '@app/utils/theme';
import Cookies from 'js-cookie';
import { config } from '@app/config';
import { getTotalNew, getTotalEntryPoint,
// getTotalProjectAgent,
getAdsRecommend, getAdsNew, getEntitlementAds, getTotalBlog, getUrgentJobAds, loadCategoriesData } from '@app/containers/Home/actions';
import GridAds from '@app/components/GridAds/GridAds';
import { resetMessage } from '@app/components/GridAds/SaveAd/action';
// import EntryPoint from '@app/components/EntryPoint';
import GridAdsProject from '@app/components/GridAdsProject/GridAdsProject';
// import NewBlogFloating from '@app/components/NewBlogFloating/NewBlogFloating';
import { checkTargetPageRecruitmentHub, getJsInfo, getTotalAdsByUser, getTotalJsdb, getUpgradeInfo, getTotalCandidateAts } from '@app/components/JsDatabase/action';
import JsDatabase from '@app/components/JsDatabase/JsDatabase';
import { fetchC2CCategories } from '@app/pages/api/categories';
import { styled } from 'linaria/react';
import ctTheme from 'clad-ui/theme/chotot';
import dynamic from 'next/dynamic';
import { loadThemeData } from '@app/modules/theme';

// import Categories from '@app/components/Categories';

const Categories = dynamic(() => import('@app/components/Categories'), {
  ssr: false
});
const RecruitmentHubEntrypoint = dynamic(() => import('@app/components/RecruitmentHub/RecruitmentHubEntrypoint'), {
  ssr: true
});
const ProtectedAdModal = dynamic(() => import('@app/components/ProtectedAdModal'), {
  loading: () => <div />,
  ssr: false
});
const Services = dynamic(() => import('@app/components/Services'), {
  loading: () => <div />,
  ssr: false
});
const Company = dynamic(() => import('@app/components/Company'), {
  loading: () => <div />,
  ssr: false
});
const ReferralProgram = dynamic(() => import('@app/components/ReferralProgram/ReferralProgram'), {
  loading: () => <div />,
  ssr: false
});
const SnackBar = dynamic(() => import('@app/components/SnackBar/SnackBar'), {
  loading: () => <div />,
  ssr: false
});
const PartnerProgram = dynamic(() => import('@app/components/PartnerProgram'), {
  loading: () => <div />,
  ssr: false
});
const Nearby = dynamic(() => import('@app/components/Nearby'), {
  loading: () => <div />,
  ssr: false
});
const JobCollection = dynamic(() => import('@app/components/JobCollection/JobCollection'), {
  loading: () => <div />,
  ssr: false
});
const ContentCard = dynamic(() => import('@app/components/ContentCard'), {
  loading: () => <div />,
  ssr: false
});
const HomeContainer = /*#__PURE__*/styled("main")({
  name: "HomeContainer",
  class: "h1sor5lr",
  vars: {
    "h1sor5lr-1": [({
      background
    }) => background && `url('${background}')`],
    "h1sor5lr-2": [({
      background
    }) => background && 'no-repeat'],
    "h1sor5lr-3": [({
      background
    }) => background && 'fixed'],
    "h1sor5lr-4": [({
      background
    }) => background && '100%']
  }
});
const WrapperHome = /*#__PURE__*/styled("div")({
  name: "WrapperHome",
  class: "w2pqa04"
});
const WrapperBanner = /*#__PURE__*/styled("div")({
  name: "WrapperBanner",
  class: "w154pun3"
});
const ContainerBanner = /*#__PURE__*/styled("div")({
  name: "ContainerBanner",
  class: "cfnyd4t",
  vars: {
    "cfnyd4t-1": [props => props.borderSliderColor ? props.borderSliderColor : '#fff']
  }
});
const Row = /*#__PURE__*/styled("div")({
  name: "Row",
  class: "r8crksz"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cokiwz8"
});
const BannerDesktopWrapper = /*#__PURE__*/styled("div")({
  name: "BannerDesktopWrapper",
  class: "b1cj3zp3"
});
const DEFAULT_REGION_ENTITLEMENT = '0';
const Home = ({
  banners,
  auth,
  isMobile,
  seo: {
    data: {
      seo: {
        seoData,
        keywords
      }
    }
  },
  dispatch,
  collections: {
    data: collectionData = {},
    isDone: isDoneCollection = false
  },
  shortcuts: {
    data: shortcutData = {},
    isDone: isDoneShortcut = false
  },
  blogCats = [],
  recruitmentHubConfig: {
    data: recHubConfig = {},
    isDone: isDoneRecHub = false
  }
}) => {
  // const [cats, setCatsBlog] = useState([]);
  const [currentCat, setCurrentCat] = useState('');
  const [total, setTotal] = useState({
    totalNew: 0,
    totalEntryPoint: 0,
    totalProject: 0,
    totalProjectAgent: 0,
    totalBlog: 0,
    totalEntitlement: 0,
    totalRecommend: 0,
    totalUrgentJobAd: 0
  });
  const [isDone, setIsDone] = useState({
    isDoneRecommend: false,
    isDoneNew: false,
    isDoneProject: false,
    isDoneProjectAgent: false,
    isDoneBlog: false,
    isDoneEntitlement: false,
    isDoneUrgentJobAd: false
  });
  const [ads, setAds] = useState({
    adRecommend: [],
    adNew: [],
    adKeywords: [],
    adProjectAgent: [],
    adBlog: [],
    adEntitlement: [],
    adUrgentJob: []
  });
  const [regionUrl, setRegionUrl] = useState('');
  const [region, setRegion] = useState({
    regionValue: 0,
    regionUrl: '',
    regionName: 'Toàn quốc',
    subRegionValue: 0,
    subRegionUrl: '',
    subRegionName: 'Tất cả'
  });
  const [scrollTop, setScrollTop] = useState(false);
  const [showProtectedAdModal, setShowProtectedAdModal] = useState(false);
  // const [isAdBlock, setAdBlock] = useState(false);
  const [isShowReferral, setIsShowReferral] = useState(false);
  const [categories, setCategories] = useState({});
  const saveAdMessage = useSelector(state => state.savedAd.message);
  const mappingFeaturesAdData = useSelector(state => state.adFeature.mapping);
  const theme = useSelector(state => state?.theme?.theme || {});
  const jsdbData = useSelector(state => state.jsDatabase);
  const getCategoriesState = async () => {
    try {
      const categoriesState = JSON.parse(sessionStorage.getItem('categoriesState') || '{}');
      if (Object.keys(categoriesState).length > 0) {
        setCategories(categoriesState);
        dispatch(loadCategoriesData(categoriesState));
      } else {
        const response = await fetchC2CCategories();
        setCategories(response);
        sessionStorage.setItem('categoriesState', JSON.stringify(response));
        dispatch(loadCategoriesData(response));
      }
    } catch (e) {
      // eslint-disable-next-line no-useless-return
      return;
    }
  };
  useEffect(() => {
    pushPageMetadata('job_homepage');
    getCategoriesState();
    dispatch(loadThemeData());
  }, []);
  useEffect(() => {
    const onScroll = () => {
      const scTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (!scrollTop && isDone.isDoneNew && scTop > scrollTop) {
        setScrollTop(true);
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollTop, total, isDone, ads]);
  useEffect(() => {
    async function fetchMyAPI() {
      const initCats = blogCats?.length > 0 ? blogCats[0].id : 1210;
      const {
        data: adBlog = [],
        total: totalBlogNumber,
        isDone: isDoneBlog = false
      } = await getTotalBlog(initCats);
      if (blogCats.length) {
        setCurrentCat(blogCats[0].slug);
      }
      setIsDone({
        ...isDone,
        isDoneBlog
      });
      setAds({
        ...ads,
        adBlog
      });
      setTotal({
        ...total,
        totalBlog: totalBlogNumber
      });
    }
    if (scrollTop) {
      fetchMyAPI();
    }
  }, [scrollTop]);
  useEffect(() => {
    let regionLocation = Cookies.get('regionParams');
    let location = Cookies.get('location');
    if (!location) {
      location = 'toan-quoc';
    }
    if (!regionLocation) {
      regionLocation = {
        regionValue: 0,
        regionUrl: 'toan-quoc',
        regionName: 'Toàn quốc',
        subRegionValue: 0,
        subRegionUrl: '',
        subRegionName: '',
        wardValue: 0,
        wardName: '',
        wardUrl: ''
      };
    } else {
      regionLocation = JSON.parse(regionLocation);
    }
    if (auth?.loaded) {
      (async () => {
        dispatch(getJsInfo());
        dispatch(getTotalJsdb());
        if (auth?.authenticated) {
          dispatch(getUpgradeInfo());
          dispatch(getTotalAdsByUser());
          dispatch(getTotalCandidateAts());
        }
        const [{
          ads: adUrgentJob = [],
          isDone: isDoneUrgentJobAd = false
        }, {
          ads: adRecommend = [],
          isDone: isDoneRecommend = true
        }, {
          ads: adNew = [],
          isDone: isDoneNew = false
        }, {
          total: totalNewNumber = 0
        }, {
          total: totalEntryPointNumber = 0
        }, {
          ads: adEntitlement = [],
          isDone: isDoneEntitlement = false,
          total: totalEntitlement = 0
        }] = await Promise.all([getUrgentJobAds(), getAdsRecommend(auth), getAdsNew(regionLocation), getTotalNew(), getTotalEntryPoint(), getEntitlementAds(regionLocation?.regionValue || DEFAULT_REGION_ENTITLEMENT)]);
        setIsDone({
          isDoneRecommend,
          isDoneNew,
          isDoneEntitlement,
          isDoneUrgentJobAd
        });
        setAds({
          adRecommend,
          adNew,
          adEntitlement,
          adUrgentJob
        });
        setRegion(regionLocation);
        if (location !== 'toan-quoc') {
          setRegionUrl(location);
        }
        setTotal({
          totalEntryPoint: totalEntryPointNumber,
          totalNew: totalNewNumber,
          totalEntitlement
        });
      })();
    }
  }, [auth?.loaded]);
  const handleCategoryClick = item => {
    gtmTracking('find_job_by_job_type', `${item.text} | ${item.index + 1}`, 'click_job_type');
  };
  const handleCategoryClickMore = (title, eventName, action = 'click_see_more') => {
    gtmTracking(eventName, title, action);
  };
  const handleServiceClick = (category, label, action) => {
    gtmTracking(category, `${label}`, action, {
      account_id: auth?.account_id || 'none',
      finger_print: Cookies.get('ctfp') || 'none',
      page_type: 'job_homepage'
    });
  };
  const handleClickAdView = (adInfo, category, action = 'click_newest_jobs') => {
    const label = `${adInfo.index} | ${adInfo.ad_id}`;
    if (['job_personalize_ads', 'slot_for_sale'].includes(category)) {
      let _label = '';
      const rest = {
        account_id: auth?.account_id || 'none',
        finger_print: Cookies.get('ctfp') || 'none',
        sub_category_id: adInfo.category || 'none',
        page_type: 'job_homepage',
        ad_id: adInfo.ad_id
      };
      if (category === 'slot_for_sale') {
        rest.category_id = 13000;
        _label = adInfo.index;
      } else {
        rest.position = adInfo.index;
      }
      if (category === 'slot_for_sale') {
        gtmTracking(category, _label, action, rest);
      } else {
        gtmTrackingWithRegion(category, _label, action, rest);
      }
    } else {
      gtmTrackingWithRegion(category, label, action);
    }
  };
  const handleClickLoadMore = (label, category) => {
    if (category === 'slot_for_sale') return;
    if (category === 'job_personalize_ads') {
      gtmTrackingWithRegion(category, '', 'click_see_more', {
        account_id: auth?.account_id || 'none',
        finger_print: Cookies.get('ctfp') || 'none',
        page_type: 'job_homepage'
      });
    } else {
      gtmTrackingWithRegion(category, label, 'click_see_more');
    }
  };
  const handleClickHelp = category => {
    const rest = {
      page_type: 'job_homepage',
      account_id: auth?.account_id || 'none',
      finger_print: Cookies.get('ctfp') || 'none',
      sub_category_id: 13010,
      category_id: 13000
    };
    gtmTrackingWithRegion(category, '', 'click_explore', rest);
  };
  const handlePopularKeywordClick = item => {
    gtmTracking('popular_keywords', item.title.replace(/\s+/g, '_').toLowerCase());
  };
  const handleBannerClick = (item, index) => {
    gtmTracking('hero_banner', `${index} | ${item.name.replace(/\s+/g, '_').toLowerCase()}`, 'click_banner');
  };
  const handleClickBlogCate = async (cat = {}) => {
    setIsDone({
      ...isDone,
      isDoneBlog: false
    });
    const {
      data: adsBlogWithCate,
      isDone: isDoneFetchBlog = false
    } = await getTotalBlog(cat.id);
    if (adsBlogWithCate && adsBlogWithCate.length && isDoneFetchBlog) {
      gtmTracking('job_blog', `${cat.name} | ${cat.id}`, 'click_blog_category_section', {
        account_id: auth?.account_id || 'none',
        finger_print: Cookies.get('ctfp') || 'none',
        page_type: 'job_homepage'
      });
      setIsDone({
        ...isDone,
        isDoneBlog: isDoneFetchBlog
      });
      setCurrentCat(cat.slug);
      setAds({
        ...ads,
        adBlog: adsBlogWithCate
      });
    }
  };
  const handleClickArticle = (adInfo, category, action) => {
    const {
      id,
      title
    } = adInfo;
    const selectedArticle = ads.adBlog.find(x => x.id === id);
    const articlePosition = ads.adBlog.findIndex(x => x.id === id);
    const selectedCats = blogCats.find(x => x.slug === currentCat);
    if (selectedArticle) {
      gtmTracking(category, `${title} | ${selectedCats.id} | ${articlePosition}`, action, {
        account_id: auth?.account_id || 'none',
        finger_print: Cookies.get('ctfp') || 'none',
        page_type: 'job_homepage'
      });
    }
  };
  const handleClickLoadMoreBlog = () => {
    const selectedCats = blogCats.find(x => x.slug === currentCat);
    if (selectedCats) {
      gtmTracking('job_blog', `${selectedCats.name} | ${selectedCats.id}`, 'click_see_more', {
        account_id: auth?.account_id || 'none',
        finger_print: Cookies.get('ctfp') || 'none',
        page_type: 'job_homepage'
      });
    }
  };
  const handleClickPartnerAd = text => {
    gtmTracking('partner_introduction', `${text}`, 'click', {
      account_id: auth?.account_id || 'none',
      finger_print: Cookies.get('ctfp') || 'none',
      page_type: 'job_homepage'
    });
  };
  const openProtectedAdModal = e => {
    e.preventDefault();
    setShowProtectedAdModal(true);
  };
  const closeProtectedAdModal = () => {
    setShowProtectedAdModal(false);
  };
  const handleClickCollection = (collection, index) => {
    gtmTracking('job_seeker', `${collection.name || collection.text} | ${index + 1} `, 'click_collection', {
      account_id: auth?.account_id || 'none',
      finger_print: Cookies.get('ctfp') || 'none',
      page_type: 'job_homepage'
    });
  };
  const handleClickContentCard = () => {
    setIsShowReferral(true);
  };
  const handleCloseReferralForm = () => {
    setIsShowReferral(false);
  };
  const handleClickRecruitmentHub = async () => {
    gtmTracking('recruiter_dashboard', '', 'click_entry_point', {
      account_id: auth?.account_id || 'none',
      finger_print: Cookies.get('ctfp') || 'none'
    });
    let url = '/nha-tuyen-dung/uu-dai-nha-tuyen-dung-moi';
    if (auth?.authenticated) {
      const response = await dispatch(checkTargetPageRecruitmentHub());
      if (response?.result?.target_page === 'manage_applicant') {
        url = '/nha-tuyen-dung';
      }
    }
    setTimeout(() => {
      window.location.href = `${config.jobURL}${url}`;
    }, 200);
  };
  const handleClickShortcutRecHub = shortcutType => {
    if (shortcutType === 'ats') {
      gtmTracking('recruiter_dashboard', '', 'click_entry_point', {
        account_id: auth?.account_id || 'none',
        finger_print: Cookies.get('ctfp') || 'none',
        page_type: 'job_homepage'
      });
    } else if (shortcutType === 'jsdb') {
      return gtmTracking('job_seeker_database', 'find_candidates', 'click_entry_point', {
        account_id: auth?.account_id || 'none',
        finger_print: Cookies.get('ctfp') || 'none',
        page_type: 'job_homepage'
      });
    }
    return gtmTracking('recruiter_dashboard', 'subscription', 'click', {
      account_id: auth?.account_id || 'none',
      finger_print: Cookies.get('ctfp') || 'none',
      category_id: 13000,
      page_type: 'job_homepage'
    });
  };
  const background = useMemo(() => getValuePatternFromTheme(theme), [theme]);
  const borderSliderColor = useMemo(() => getValuePatternFromTheme(theme, 'border-slider-color-job'), [theme]);
  const sliderTheme = useMemo(() => getSliderFromTheme(theme), [theme]);
  const memoizedHandleCategoryClick = useCallback(handleCategoryClick, []);
  const memoizedHandleCategoryClickMore = useCallback(handleCategoryClickMore, []);
  const memoizedHandleClickAdView = useCallback(handleClickAdView, []);
  const memoizedHandleClickLoadMore = useCallback(handleClickLoadMore, []);
  const memoizedHandleClickHelp = useCallback(handleClickHelp, []);
  const memoizedHandlePopularKeywordClick = useCallback(handlePopularKeywordClick, []);
  const memoizedHandleBannerClick = useCallback(handleBannerClick, []);
  const memoizedHandleClickCollection = useCallback(handleClickCollection, []);
  const memoizedHandleClickRecruitmentHub = useCallback(handleClickRecruitmentHub, []);
  const memoizedHandleClickShortcutRecHub = useCallback(handleClickShortcutRecHub, []);
  const memoizedHandleClickPartnerAd = useCallback(handleClickPartnerAd, []);
  const {
    allCategoryFollowId: allCategoriesFollowId
  } = categories;
  return <>
      <Head>
        <title>{seoData?.title}</title>
        {seoData.meta && seoData?.meta.map((item, index) => <meta key={index.toString()} {...item} />)}
        <meta property="og:title" content={seoData?.title} />
        <meta property="og:description" content={seoData?.meta[0] && seoData?.meta[0].name === 'description' && seoData?.meta[0].content} />
        <meta property="og:image" content={config.jobMeta['og:image']} />
        <meta property="og:url" content={config.jobMeta['og:url']} />
        <meta property="og:type" content="website" />
      </Head>
      <HomeContainer background={background}>
        <WrapperBanner>
          <ContainerBanner borderSliderColor={borderSliderColor}>
            <BannerDesktopWrapper>
              <DesktopSlider isMobile={isMobile} bannerList={banners} onClick={(item, index) => memoizedHandleBannerClick(item, index)} sliderTheme={sliderTheme} />
            </BannerDesktopWrapper>
          </ContainerBanner>
        </WrapperBanner>

        <WrapperHome>
          <Categories region={region} total={total} label={shortcutData['JOB-JOBS']?.label} allCategoriesFollowId={shortcutData['JOB-JOBS']?.quick_shortcut} description={shortcutData['JOB-JOBS']?.description} onClick={memoizedHandleCategoryClick} handleClickMore={memoizedHandleCategoryClickMore} />
          <RecruitmentHubEntrypoint configData={recHubConfig} isDone={isDoneRecHub} onClick={memoizedHandleClickRecruitmentHub} data={jsdbData} isMobile={isMobile} onClickShortcut={memoizedHandleClickShortcutRecHub} />
          <GridAds key="urgent-job-ad" type="urgent-job-ad" isDone={isDone.isDoneUrgentJobAd} title="&#128293; Việc làm tuyển gấp" link={`${config.jobURL}/viec-lam?job_urgent_recruit_enabled=1`} region={region} ads={ads.adUrgentJob} accountId={auth?.account_id || 'none'} mappingFeaturesAdData={mappingFeaturesAdData} allCategoriesFollowId={allCategoriesFollowId} handleClickAdView={memoizedHandleClickAdView} handleClickLoadMore={memoizedHandleClickLoadMore} handleClickHelp={memoizedHandleClickHelp} isMobile={isMobile} />
          <ContentCard auth={auth} isMobile={isMobile} onClickContentCard={handleClickContentCard} />
          <Nearby isMobile={isMobile} auth={auth} dispatch={dispatch} />
          <JobCollection isMobile={isMobile} collections={collectionData} onClickItem={memoizedHandleClickCollection} isDone={isDoneCollection} />
          <GridAds key="adrecommend" type="adrecommend" isDone={isDone.isDoneRecommend} title="Việc làm dành cho bạn" link={`${config.jobURL}/tin-dang-danh-cho-ban?cg=13010`} region={region} ads={ads.adRecommend?.length ? ads.adRecommend.slice(0, 10) : []} total={total.totalRecommend} accountId={auth?.account_id || 'none'} openProtectedAdModal={openProtectedAdModal} mappingFeaturesAdData={mappingFeaturesAdData} allCategoriesFollowId={allCategoriesFollowId} handleClickAdView={memoizedHandleClickAdView} handleClickLoadMore={memoizedHandleClickLoadMore} />
          <JsDatabase isMobile={isMobile} auth={auth} dispatch={dispatch} />
          <GridAds key="adnew" type="adnew" isDone={isDone.isDoneNew} title="Việc làm mới nhất" link={`${config.jobURL}/viec-lam${regionUrl !== '' ? '-' + regionUrl : ''}`} region={region} ads={ads.adNew} total={total.totalNew} accountId={auth?.account_id || 'none'} openProtectedAdModal={openProtectedAdModal} mappingFeaturesAdData={mappingFeaturesAdData} allCategoriesFollowId={allCategoriesFollowId} handleClickAdView={memoizedHandleClickAdView} handleClickLoadMore={memoizedHandleClickLoadMore} />
          <PartnerProgram description={shortcutData['JOB_HOMEPAGE-PARTNER_PROGRAM_INTRODUCTION']?.description || ''} isDone={isDoneShortcut} services={shortcutData['JOB_HOMEPAGE-PARTNER_PROGRAM_INTRODUCTION']?.quick_shortcut} region={region} onClickPartnerAd={memoizedHandleClickPartnerAd} onClickSeeMore={() => handleServiceClick('partner_introduction', 'see_more', 'click')} />
          <GridAds key="entitlement" type="entitlement" isDone={isDone.isDoneEntitlement} title="Từ Đối Tác Việc Làm Tốt" link={`${config.jobURL}/viec-lam${regionUrl !== '' ? '-' + regionUrl : ''}?f=protection_entitlement`} region={region} ads={ads.adEntitlement} total={total.totalEntitlement} accountId={auth?.account_id || 'none'} openProtectedAdModal={openProtectedAdModal} mappingFeaturesAdData={mappingFeaturesAdData} allCategoriesFollowId={allCategoriesFollowId} handleClickAdView={memoizedHandleClickAdView} handleClickLoadMore={memoizedHandleClickLoadMore} isMobile={isMobile} />

          <Company services={shortcutData['JOB-COMPANIES']?.quick_shortcut} region={region} isDone={isDoneShortcut} onClick={item => handleServiceClick('job_by_company', `${item.index} | ${item.text}`, 'click_job_company')} />

          <GridAdsProject key="adBlog" type="blog" isDone={isDone.isDoneBlog || false} title="Trang kinh nghiệm việc làm" link={`${config.jobURL}/kinh-nghiem/${currentCat}`} region={region} ads={ads?.adBlog || []} cats={blogCats} total={total.totalBlog} isMobile={isMobile || false} accountId={auth?.account_id || 'none'} mappingFeaturesAdData={mappingFeaturesAdData} handleClickAdView={handleClickArticle} handleClickLoadMore={handleClickLoadMoreBlog} handleClickBlogCate={handleClickBlogCate} isAdBlock={false} />

          <Services description={shortcutData['JOB-INTRODUCTION']?.description || ''} services={shortcutData['JOB-INTRODUCTION']?.quick_shortcut} isDone={isDoneShortcut} region={region} onClick={() => handleServiceClick('job_introduction', 'Giới thiệu Việc Làm Tốt', 'click_introduction')} />

          {seoData?.catDescription && <Container>
              {seoData.catDescription && <Description content={seoData.catDescription} />}
            </Container>}

          {keywords && <Container>
              {keywords.length > 0 && <Row className="hidden-xs">
                  <Keywords isMobile={isMobile} onClick={item => memoizedHandlePopularKeywordClick(item)} dataSource={keywords} />
                </Row>}
            </Container>}
          <JobFloatingButton auth={auth} isClient={isClient} />
          {saveAdMessage && <SnackBar hideCallBack={() => dispatch(resetMessage())} message={saveAdMessage} />}

          <ProtectedAdModal show={showProtectedAdModal} onClose={closeProtectedAdModal} />
        </WrapperHome>
        {isMobile && <ReferralProgram auth={auth} dispatch={dispatch} isShowReferral={isShowReferral} onCloseReferralForm={handleCloseReferralForm} />}
      </HomeContainer>
    </>;
};
export default Home;

require("../../../.linaria-cache/src/containers/Home/index.linaria.module.css");